import { render, staticRenderFns } from "./ProductsScrollCarousel.vue?vue&type=template&id=5394adcd&"
import script from "./ProductsScrollCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductsScrollCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports